import { TableHead } from 'components/Table/types';
import { RoleTypes } from 'utils/rolesTypes';

export const MAX_INPUT_LENGTH = 255;

export const TRIPS_HEAD_DATA: TableHead[] = [
  {
    label: 'TABLE.HEAD.TITLE',
    key: 'tripReason',
    align: 'left',
    sortable: false,
    role: RoleTypes.RoleEmployee,
  },
  {
    label: 'TABLE.HEAD.NAME',
    key: 'name',
    align: 'left',
    sortable: false,
    role: RoleTypes.RoleAccounting,
  },
  {
    label: 'TABLE.HEAD.CLIENT',
    key: 'client',
    align: 'center',
    sortable: false,
    role: RoleTypes.RoleEmployee,
  },
  {
    label: 'TABLE.HEAD.PROJECT',
    key: 'project',
    align: 'center',
    sortable: false,
    role: RoleTypes.RoleEmployee,
  },
  {
    label: 'BUSINESS_TRIP.WORK_ORDER',
    key: 'orderNumber',
    align: 'center',
    sortable: false,
    role: RoleTypes.RoleEmployee,
  },
  {
    label: 'TABLE.HEAD.STATUS',
    key: 'status',
    align: 'center',
    sortable: false,
    role: RoleTypes.RoleEmployee,
  },
  {
    label: 'TABLE.HEAD.DATES',
    key: 'dates',
    align: 'center',
    sortable: false,
    role: RoleTypes.RoleEmployee,
  },
  {
    label: 'TABLE.HEAD.DESCRIPTION',
    key: 'details',
    align: 'center',
    sortable: false,
    role: RoleTypes.RoleEmployee,
  },
  {
    label: 'TABLE.HEAD.ACTIONS',
    key: 'actions',
    align: 'center',
    sortable: false,
    role: RoleTypes.RoleEmployee,
  },
];

export const STATUS_LIST = [
  { name: 'DRAFT' },
  { name: 'SENT' },
  { name: 'FINISHED' },
  { name: 'SETTLED' },
  { name: 'CANCELED' },
];
